// react components
import React from 'react'
import axios, {
    CancelTokenSource,
} from 'axios'

// data
import {
    contentTypeModelTypeSite,
    errorMessageToSkipSite,
    reduxAuthStateSite,
    reduxModalStateSite,
} from 'data'

// serializers
import {
    ContentTypeSettingsTypes,
} from 'serializers/site'

// services
import {
    axiosErrorHandlerSite,
    getAxiosHeadersSite,
} from 'services'

export const listStateInitialSite = {
    clusterIds: undefined,
    contentType: undefined,
    contentTypeSettings: undefined,
    count: undefined,
    disableInfiniteScroll: true,
    hasMore: true,
    ids_to_lahoun: '0',
    isLoading: true,
    items: [],
    nextUrl: '',
}

// types
export interface listStatePropsSite {
    clusterIds: number[] | undefined
    contentType: contentTypeModelTypeSite | undefined
    contentTypeSettings: ContentTypeSettingsTypes | undefined
    count: number | undefined
    disableInfiniteScroll: boolean
    hasMore: boolean
    ids_to_lahoun: string
    isLoading: boolean
    items: any[]
    modalKey: number
    nextUrl: string
}

// main
export function getInfiniteListItemSite({
    apiUrl,
    axiosCancelToken,
    changingView,
    component,
    dispatch,
    listState,
    noClusterIds,
    noEmptyItems,
    onSuccess,
    reduxAuth,
    reduxModalSite,
    setAxiosCancelToken,
    setListState,
}: {
    apiUrl: string
    axiosCancelToken: CancelTokenSource | undefined
    changingView: boolean
    component: string
    dispatch: React.Dispatch<any>
    listState: listStatePropsSite
    noClusterIds?: boolean
    noEmptyItems?: boolean
    onSuccess?: (e: any, items: any[]) => void
    reduxAuth: reduxAuthStateSite
    reduxModalSite: reduxModalStateSite
    setAxiosCancelToken: React.Dispatch<CancelTokenSource | undefined>
    setListState: React.Dispatch<listStatePropsSite>
}) {

    if (!apiUrl) return

    if (changingView) {
        if (noEmptyItems) {
            setListState({
                ...listState,
                count: undefined,
                disableInfiniteScroll: true,
                hasMore: true,
                isLoading: true,
                nextUrl: '',
            })
        } else {
            setListState({
                ...listState,
                count: undefined,
                disableInfiniteScroll: true,
                hasMore: true,
                isLoading: true,
                items: [],
                nextUrl: '',
            })
        }
    } else {
        setListState({
            ...listState,
            disableInfiniteScroll: true,
            isLoading: true,
        })
    }

    if (axiosCancelToken) axiosCancelToken.cancel('axios canceled')

    const refreshAxiosHeaders = getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch)

    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    setAxiosCancelToken(source)

    if (process.env.NODE_ENV === 'development') console.log(apiUrl, component)

    const formData: any = new FormData()
    if (!noClusterIds && listState.clusterIds) {
        formData.append('ids_cluster', listState.clusterIds?.join(','))
    }

    axios({
        data: formData,
        headers: refreshAxiosHeaders,
        method: (!noClusterIds && listState.clusterIds?.length! > 0) ? 'post' : 'get',
        url: apiUrl,
        cancelToken: source.token,
    })
        .then((response) => {
            if (process.env.NODE_ENV === 'development') console.log(response)
            const dataToReturn = changingView ? response.data.results : [...listState.items, ...response.data.results]
            setListState({
                ...listState,
                contentType: response.data.content_type,
                contentTypeSettings: response.data.content_type_settings_json,
                count: response.data.count,
                disableInfiniteScroll: response.data.next === null,
                hasMore: response.data.next !== null,
                isLoading: false,
                items: dataToReturn,
                nextUrl: response.data.next,
            })
            if (onSuccess) onSuccess(response.data, dataToReturn)
        })
        .catch((error) => {
            if (error.message === 'axios canceled') {
                if (process.env.NODE_ENV === 'development') console.log(error)
                return
            }
            if (errorMessageToSkipSite.includes(error.message)) {
                setListState({
                    ...listState,
                    disableInfiniteScroll: false,
                    isLoading: false,
                })
            } else if (errorMessageToSkipSite.includes(error)) {
                setListState({
                    ...listState,
                    disableInfiniteScroll: false,
                    isLoading: false,
                })
            } else {
                setListState({
                    ...listState,
                    disableInfiniteScroll: true,
                    isLoading: false,
                })
            }
            axiosErrorHandlerSite({
                apiUrl,
                component,
                dispatch,
                error,
                reduxAuth,
                reduxModalSite,
                reference: 'getInfiniteListItemSite',
                skipSendError: (error.response?.status === 404) && (['Invalid page.', 'Page non valide.', 'Not found.', 'Pas trouvé.'].includes(error.response?.data?.detail)),
            })
        })
}
